import { defineMessages } from "react-intl"

export const conditionAndServiceFormMessages = defineMessages({
	batteryInformationTitle: {
		defaultMessage: "Battery information",
		id: "conditionAndHistory.batteryInformation.title",
	},
	carPassSubtitle: {
		defaultMessage: "Provide the link to Car-Pass for this vehicle. Visible to customers.",
		id: "conditionAndHistory.carPass.subtitle",
	},
	carPassTitle: {
		defaultMessage: "Car-Pass",
		id: "conditionAndHistory.carPass.title",
	},
	damageHistoryTitle: {
		defaultMessage: "Damage history",
		id: "conditionAndHistory.damageHistory.title",
	},
	generalInformationTitle: {
		defaultMessage: "General information",
		id: "conditionAndHistory.generalInformation.title",
	},
	lastMaintenanceSubtitleNew: {
		defaultMessage:
			"Please add details about the last service to increase transparency for our customers. This information is only relevant for used cars that are older than two years or have a mileage of more than 30,000 km.",
		id: "conditionAndHistory.lastMaintenance.subtitleNew",
	},
	lastMaintenanceTitle: {
		defaultMessage: "Last maintenance",
		id: "conditionAndHistory.lastMaintenance.title",
	},
	pcssLink: {
		defaultMessage: "PCSS",
		id: "conditionAndHistory.pcssLink",
	},
	precontractualInformation: {
		defaultMessage: "Pre-contractual information",
		id: "conditionAndHistory.precontractualInformation.title",
	},
	serviceHistoryTitle: {
		defaultMessage: "Service History",
		id: "conditionAndHistory.serviceHistory.title",
	},
})
